import { motion } from "framer-motion";
import { TOPICS, IMG } from "@/lib/platform";

const TOPIC_IMAGES = [IMG.arch1, IMG.arch2, IMG.arch3, IMG.finale, IMG.arch2, IMG.arch1];

export default function Topics() {
  return (
    <section data-testid="topics-section" className="relative bg-[#0B1F3D] text-[#F5EBD9] py-24 lg:py-36">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9 }}
          className="mb-14 lg:mb-20"
        >
          <div className="font-mono text-[11px] uppercase tracking-[0.32em] text-[#F5892E] mb-4 flex items-center gap-4">
            <span className="h-px w-10 bg-[#F5892E]" />
            Какво ще научиш
          </div>
          <h2 className="font-display uppercase text-4xl sm:text-5xl lg:text-7xl leading-[0.95] tracking-tight max-w-5xl">
            Пазарът се променя.<br />
            <span className="text-[#F5892E]">А ти го разбираш ли?</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {TOPICS.map((t, i) => (
            <motion.div
              key={t.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.7, delay: (i % 3) * 0.1 }}
              data-testid={`topic-${i}`}
              className="group relative overflow-hidden rounded-2xl border border-[#1E3A63] bg-[#0F284B] hover:border-[#F5892E]/60 transition-colors duration-500"
            >
              <div className="relative h-44 overflow-hidden">
                <div
                  className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-105 opacity-70"
                  style={{ backgroundImage: `url(${TOPIC_IMAGES[i]})` }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0F284B] via-[#0F284B]/50 to-transparent" />
                <div className="absolute bottom-4 left-5 font-mono text-[10px] uppercase tracking-[0.3em] text-[#F5892E]">
                  Тема {String(i + 1).padStart(2, "0")}
                </div>
              </div>
              <div className="p-6 lg:p-7">
                <h3 className="font-display uppercase text-xl sm:text-2xl tracking-tight leading-tight mb-3">
                  {t.title}
                </h3>
                <p className="text-[#C8D4E6] text-sm leading-relaxed">{t.text}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="mt-10 text-center font-mono text-[10px] sm:text-[11px] uppercase tracking-[0.26em] text-[#8A9EB8]"
        >
          Това са водещите теми на бранда — официалната програма и лекторите за Варна 2027 ще бъдат обявени по-късно.
        </motion.p>
      </div>
    </section>
  );
}
